import React, { useState } from "react";
import "./Login.css";
import { Link, useNavigate } from "react-router-dom";
import "toastr/build/toastr.min.css";
import toastr from "toastr";
import apiServiceHandler from "../../service/apiService"
import { useDispatch } from 'react-redux'
import { updateUserDetails } from "../../redux/userData/index";
import Logo from '../../assets/image.png'

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch()

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const togglePasswordVisibile = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    const payload = {
      email,
      password,
    };
    try {
      const response = await apiServiceHandler("POST", "api/auth/login", { ...payload });
      // console.log('Data is here...', response)
      if (response.auth) {
        const token = response.token.split(' ')[1];
        localStorage.setItem("STG_TOKEN", token);
        localStorage.setItem("userDetails", JSON.stringify(response.user));
        dispatch(updateUserDetails(response.user));
        navigate("/daily-work");
      } else {
        toastr.error(response.message || "Failed to log in. Please try again.")
      }
    } catch (error) {
      toastr.error(error?.response?.data.message);
      console.error(error.response);
    }
  };

  return (
    <main className="auth">
      <div className="auth-layout">
        <div className="auth-view">
          <div className="login-auth-view__container">
            <div className="login-auth-logo">
              <img src={Logo} />
            </div>
            <div className="login-view">
              <div className="login-heading">LOG IN</div>
              <form className="login-form" onSubmit={handleLogin}>
                <div className="login-view__field">
                  <div className="login-view__field-input" name="email">
                    <div className="text-input_input-wrapper">
                      <input
                        type="text"
                        className="auth-text-input__input"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="login-view__field">
                  <div className="login-view__field-input" name="password">
                    <div className="text-input_input-wrapper">
                      <input
                        type={passwordVisible ? "text" : "password"}
                        className="auth-text-input__input"
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                      <span className="icon-eye" onClick={togglePasswordVisibile}>
                        {!passwordVisible ? (
                          <svg
                            viewBox="0 0 24 15"
                            fill="#d1b794"
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon__svg"
                            preserveAspectRatio="xMidYMid meet"
                            style={{ width: "20px", height: "20px" }}
                          >
                            <path d="M11.993.5C6.333.5 1.346 4.423.023 9.563a.75.75 0 001.453.374C2.616 5.507 7.033 2 11.993 2c4.96 0 9.39 3.508 10.53 7.937a.75.75 0 001.453-.374C22.653 4.422 17.653.5 11.993.5zm.008 4a4.843 4.843 0 00-4.832 4.832A4.844 4.844 0 0012 14.165a4.845 4.845 0 004.833-4.833A4.844 4.844 0 0012 4.5z"></path>
                          </svg>
                        ) : (
                          <svg
                            viewBox="0 0 24 22"
                            fill="#d1b794"
                            xmlns="http://www.w3.org/2000/svg"
                            class="icon__svg"
                            preserveAspectRatio="xMidYMid meet"
                            style={{ width: "20px", height: "20px" }}
                          >
                            <path d="M21.235.993a.75.75 0 00-.515.227l-6.707 6.707-.007-.004-6.583 6.582.004.008L2.22 19.72a.75.75 0 101.06 1.06l4.977-4.976A4.98 4.98 0 0012 17.5c2.757 0 5-2.243 5-5 0-1.49-.658-2.827-1.696-3.743l2.222-2.223c2.426 1.42 4.308 3.714 5 6.4a.747.747 0 00.909.54.74.74 0 00.54-.909c-.77-3-2.744-5.528-5.336-7.143L21.78 2.28a.75.75 0 00-.545-1.287zM11.995 3.5C6.41 3.5 1.375 7.31.025 12.565a.74.74 0 00.54.91.74.74 0 00.91-.54C2.64 8.41 7.165 5 11.995 5c.855 0 1.7.105 2.515.31l1.23-1.23a12.346 12.346 0 00-3.745-.58zm.005 4c-2.757 0-5 2.243-5 5 0 .098.009.195.015.293l5.278-5.278c-.098-.006-.194-.015-.293-.015zm.816 3.744a1.5 1.5 0 11-2.072 2.072l2.072-2.072z"></path>
                          </svg>
                        )}
                      </span>
                    </div>
                  </div>
                </div>

                <button type="submit" className="login-btn ">
                  <span className="login-button__label">LOG IN</span>
                </button>

              </form>
              <div className="login-view__footer">
                <Link to="/reset-password" className="login-link">
                  Reset password
                </Link>
                <div style={{ display: "flex", gap: "0.5rem" }}>
                  <span style={{color: '#fff'}}>Don't have an account?</span>
                  <Link to="/signup" className="login-link">
                    Signup
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Login;
